// Replaced at build time: the Dockerfile passes the pipeline's VersionTag via "ng build --define",
// angular.json defaults it to an empty string for local builds.
declare const APP_BUILD_VERSION: string;

/** Build number of the pipeline run this bundle comes from (#6388); empty in a local build. */
export const BUILD_VERSION: string = APP_BUILD_VERSION;

/**
 * Compares two build numbers of the shape `<BaseVersion>.<Revision>`, with an optional `-rc` suffix
 * on branch builds. Returns a negative number when `a` is older than `b`, zero when both are equal
 * and a positive number when `a` is newer. Numbers that cannot be parsed count as older when they
 * differ: backoffice and API are always rolled out together, so any difference means a stale build.
 */
export function compareBuildVersions(a: string, b: string): number {
  const parse = (version: string) => version.split('-')[0].split('.').map((part) => Number(part));
  const partsA = parse(a);
  const partsB = parse(b);
  if ([...partsA, ...partsB].some((part) => !Number.isInteger(part))) {
    return a === b ? 0 : -1;
  }

  for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
    const difference = (partsA[i] ?? 0) - (partsB[i] ?? 0);
    if (difference !== 0) {
      return difference;
    }
  }
  return 0;
}
